export const GET_PARTNER_RESOURCES_QUERY = gql`
    query GetPartnerResources($configuring: Boolean) {
        getPartnerResources(configuring: $configuring) {
            id
            name
            status
            pinnedAt
            createdByName
            createdAt
            order
            resources {
                id
                name
                status
                type
                description
                imageUrl
                resourceUrl
                createdAt
                createdById
                permission
                section {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_ALL_PARTNER_RESOURCES_QUERY = gql`
    query getAllPartnerResources {
        getAllPartnerResources {
            id
            name
            status
            type
            description
            imageUrl
            resourceUrl
            createdAt
            createdById
            permission

            section {
                id
                name
                status
                pinnedAt
            }
        }
    }
`;
